module.exports = __webpack_public_path__ + "img/Group 5317@2x.a6e72f1d.png";